import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-delete-icon, app-delete-icon-button',
  templateUrl: './app-delete-icon-button.component.html',
  styleUrls: ['./app-delete-icon-button.component.scss'],
})
export class AppDeleteIconButtonComponent {
  @Input() disabled: boolean = false;
  @Input() title: string = 'Delete';
  @Input() customClass: string = '';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() stopPropagation: boolean = true;
  @Output() btnClick = new EventEmitter<MouseEvent>();
  @Output() click = new EventEmitter<MouseEvent>();

  handleClick(event: MouseEvent): void {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (this.stopPropagation) {
      event.stopPropagation();
    }
    this.btnClick.emit(event);
    this.click.emit(event);
  }
}

